import { StateModel } from 'src/shared/models';
import {
  GET_SURVEY_SUBSCRIBERS,
  GET_SURVEY_SUBSCRIBERS_ERROR,
  GET_SURVEY_SUBSCRIBERS_SUCCESS,
} from '../actions/surveys.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: {},
};

export const surveySubscribersReducer = (
  state: StateModel = INITIAL_STATE,
  { type, payload, error }: any,
) => {
  switch (type) {
    case GET_SURVEY_SUBSCRIBERS:
      return {
        ...state,
        loaded: false,
        loading: true,
      };
    case GET_SURVEY_SUBSCRIBERS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: payload,
      };
    case GET_SURVEY_SUBSCRIBERS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error,
      };
    default:
      return state;
  }
};

export default surveySubscribersReducer;
